import { Result } from '@blade/std-lib'
import { reatomDataTable } from '@root/shared/ui-kit'

import { BackOfficeUsersTableColumn } from '../ui/columns'

import { reatomBackOfficeUsersListRequestAction } from './reatom-back-office-users-list-request-action'

import type { BackOfficeUser } from '@root/entities/back-office'

export const reatomBackOfficeUsersSearch = () => {
  const tableModel = reatomDataTable({
    columns: [
      BackOfficeUsersTableColumn.Avatar,
      BackOfficeUsersTableColumn.Id,
      BackOfficeUsersTableColumn.Name,
      BackOfficeUsersTableColumn.Activity,
      BackOfficeUsersTableColumn.Status,
      BackOfficeUsersTableColumn.Wallets,
      BackOfficeUsersTableColumn.UpdatedAt,
      BackOfficeUsersTableColumn.CreatedAt,
    ],
    // eslint-disable-next-line @reatom/unit-naming-rule
    name: 'back-office-users-table',
    getId: (item: BackOfficeUser.BackOfficeUser) => item.delugeId,
    loadItems: async (ctx, { pagination: { limit, cursor }, filters }) => {
      const query =
        filters.name?.type === 'string'
          ? filters.name.value || undefined
          : undefined

      const blocked = (() => {
        if (filters.activity?.type === 'custom') {
          if (filters.activity.value === 'active') {
            return false
          }
          if (filters.activity.value === 'blocked') {
            return true
          }
        }
      })()

      const requestResult = await ctx.schedule(() =>
        // eslint-disable-next-line @reatom/unit-naming-rule
        reatomBackOfficeUsersListRequestAction(ctx, {
          cursor,
          limit,
          query: query,
          blocked,
        }),
      )

      return Result.map(requestResult, (x) => ({
        data: x.data,
        hasNext: x.meta.hasNext,
        cursor: x.meta.nextCursor,
      }))
    },
  })

  return {
    tableModel,
  }
}

export type BackOfficeUsersSearchModel = ReturnType<
  typeof reatomBackOfficeUsersSearch
>
